export type ValidationResult = {
  isValid: boolean;
  errorMessage?: string;
};

const isPositive = (v: any) => typeof v === 'number' && v > 0;
const isPercentage = (v: any) => typeof v === 'number' && v > 0 && v < 100;

export const validateOffer = (offerType: string | null, form: any): ValidationResult => {
  if (!offerType) {
    return { isValid: false, errorMessage: 'Tipo de oferta obrigatório para o cadastro de oferta' };
  }

  switch (offerType) {
    case 'SIMPLE_PRICE':
      if (!isPositive(form.offer_price)) {
        return { isValid: false, errorMessage: 'Preço da oferta precisa ser maior do que 0' };
      }
      break;

    case 'SIMPLE_PERCENTAGE':
      if (!isPercentage(form.percentage_discount)) {
        return { isValid: false, errorMessage: 'Valor do desconto deve ser maior que 0 e menor que 100%' };
      }
      break;

    case 'FROM_TO':
      if (!isPositive(form.from) || !isPositive(form.to)) {
        return { isValid: false, errorMessage: 'Os valores "De" e "Por" devem ser maiores do que 0' };
      }
      break;

    case 'BUY_PAY_QUANTITY':
      if (!isPositive(form.buy_quantity) || !isPositive(form.pay_quantity) || !(form.pay_quantity < form.buy_quantity)) {
        return { isValid: false, errorMessage: 'Quantidades inválidas. "Pague" deve ser menor que "Leve" e ambos maiores que 0' };
      }
      break;

    case 'BUY_GET_DISCOUNT':
      if (!isPositive(form.buy_quantity) || !isPercentage(form.percentage_discount)) {
        return { isValid: false, errorMessage: 'Informe uma quantidade válida e um desconto entre 0 e 100%' };
      }
      break;

    case 'UNIT_DISCOUNT':
      if (!isPercentage(form.percentage_discount) || !(typeof form.unit_buy === 'number' && form.unit_buy > 1)) {
        return { isValid: false, errorMessage: 'Defina um desconto entre 0 e 100% e a unidade a partir da 2ª' };
      }
      break;

    case 'BULK_PERCENTAGE':
      if (!isPositive(form.minimum_quantity) || !isPercentage(form.percentage_discount)) {
        return { isValid: false, errorMessage: 'Informe a quantidade mínima e um desconto entre 0 e 100%' };
      }
      break;

    case 'BULK_PRICE':
      if (!isPositive(form.minimum_quantity) || !isPositive(form.price_per_unit)) {
        return { isValid: false, errorMessage: 'Informe a quantidade mínima e o preço por unidade maiores que 0' };
      }
      break;

    default:
      return { isValid: false, errorMessage: 'Tipo de oferta inválido' };
  }

  return { isValid: true };
};
